<sds-dialog *transloco="let t; read: 'onboarding'" data-testid="onboardingWizard" [closeOnOverlayClick]="false">
  <sds-card imageHeader="left" class="nscp-onboarding-wizard__card">
    <aside sds-card-aside class="nscp-onboarding-wizard__sidebar">
      <h2 class="nscp-onboarding-wizard__sidebar-heading">{{ t('wizard.heading') }}</h2>
      <p class="nscp-onboarding-wizard__sidebar-subheading">{{ t('wizard.subheading') }}</p>

      <nscp-onboarding-stepper [steps]="stepperSteps()" [currentIndex]="currentIndex()" />
    </aside>

    <div #onboardingWizardBody sdsCardBleedBlockEnd="full" class="nscp-onboarding-wizard__body" [class.nscp-onboarding-wizard__body--completed]="isOnCompletedStep()">
      <div #stepContent class="nscp-onboarding-wizard__step-content" [style.min-height.px]="maxStepContentHeight()">
        @if (!isOnCompletedStep()) {
          <div class="nscp-onboarding-wizard__step-heading">{{ t('steps.' + currentTaskKey() + '.title') }}</div>
        }

        @if (currentStepIntro()) {
          <p class="nscp-onboarding-wizard__step-intro">{{ currentStepIntro() }}</p>
        }

        @switch (currentTaskKey()) {
          @case ('communicationPreferences') {
            <nscp-communication-preferences columns="two" loadingErrorSource="onboarding" />
          }
          @case ('inviteManager') {
            <nscp-invite-manager-step />
          }
          @case ('downloadApp') {
            <nscp-download-app-step />
          }
          @default {
            <div class="nscp-onboarding-wizard__completed">
              <sds-icon name="sdsCheckCircle" filled class="nscp-onboarding-wizard__completed-icon" />
              <p class="nscp-onboarding-wizard__completed-title">{{ t('steps.completed.title') }}</p>
              <p class="nscp-onboarding-wizard__completed-description">{{ t('steps.completed.intro') }}</p>
              <button sds-button variant="primary" type="button" data-testid="onboardingWizardNext" (click)="onNext()">
                {{ t('steps.completed.action') }}
              </button>
            </div>
          }
        }

        @if (currentStepDisclaimer()) {
          <p class="nscp-onboarding-wizard__step-disclaimer">{{ currentStepDisclaimer() }}</p>
        }

        <!-- The invite step's primary action now lives in the card content (per design), not the
             shared footer - the wizard-level onNext()/canSubmit()/isCompletingTask() it's bound to
             are unchanged, only its DOM location moved. -->
        @if (currentTaskKey() === 'inviteManager') {
          <button
            sds-button
            intent="action"
            variant="primary"
            type="button"
            data-testid="onboardingWizardNext"
            class="nscp-onboarding-wizard__invite-submit"
            [disabled]="isCompletingTask() || !canSubmit()"
            [loading]="isCompletingTask()"
            (click)="onNext()"
          >
            <sds-icon name="sdsEnvelopeSimple" />
            {{ primaryActionLabel() }}
          </button>
        }
      </div>
    </div>

    <!-- No footer at all once every task is completed - its "Naar overzicht" button lives in the
         centered completed content above instead. -->
    @if (!isOnCompletedStep()) {
      <footer sds-card-footer class="nscp-onboarding-wizard__footer">
        @if (canGoBack()) {
          <button sds-button variant="subtle" type="button" data-testid="onboardingWizardPrevious" (click)="onPrevious()">
            {{ t('actions.previous') }}
          </button>
        }

        @if (canSkip()) {
          <button
            sds-button
            variant="default"
            type="button"
            data-testid="onboardingWizardSkip"
            class="nscp-onboarding-wizard__skip"
            [disabled]="isCompletingTask()"
            (click)="onSkip()"
          >
            {{ t('actions.skip') }}
          </button>
        }

        <!-- Same testid/bindings as the body's copy above for inviteManager - that case and this
             one are mutually exclusive, so exactly one "primary" control ever renders at a time.
             Hidden for communicationPreferences once its save has failed - canSkip() renders a
             "Skip" button above instead, so the user isn't forced to keep trying. -->
        @if (canShowNext()) {
          <button
            sds-button
            variant="primary"
            type="button"
            data-testid="onboardingWizardNext"
            [disabled]="isCompletingTask() || !canSubmit()"
            [loading]="isCompletingTask()"
            (click)="onNext()"
          >
            {{ primaryActionLabel() }}
          </button>
        }
      </footer>
    }
  </sds-card>
</sds-dialog>
